import { HighlightedMatch } from '@magnetic/highlighted-match';
import { useId, useClassNames } from '@magnetic/hooks';
import React, { forwardRef } from 'react';

const Item = forwardRef(
  ({ active, children, value = "", ...rest }, ref) => {
    const id = useId();
    const classNames = useClassNames(
      "mds-rebuild-input-autocomplete-menu-item",
      active && "mds-rebuild-input-autocomplete-menu-item-active"
    );
    return /* @__PURE__ */ React.createElement("div", {
      "aria-selected": active,
      className: classNames,
      id,
      ref,
      role: "option",
      ...rest
    }, /* @__PURE__ */ React.createElement(HighlightedMatch, {
      searchTerm: value
    }, children));
  }
);

export { Item };
//# sourceMappingURL=item.js.map
